import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import MovieDetail from "@/pages/MovieDetail";
import Countries from "@/pages/Countries";
import CountryDetail from "@/pages/CountryDetail";
import Cities from "@/pages/Cities";
import CityDetail from "@/pages/CityDetail";
import Genres from "@/pages/Genres";
import People from "@/pages/People";
import PersonDetail from "@/pages/PersonDetail";
import Festivals from "@/pages/Festivals";
import News from "@/pages/News";
import ArticleDetail from "@/pages/ArticleDetail";
import Community from "@/pages/Community";
import ThreadDetail from "@/pages/ThreadDetail";
import TopicPage from "@/pages/TopicPage";
import Watchlist from "@/pages/Watchlist";
import SocialPulseCallback from "@/pages/SocialPulseCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/movie/:id" element={<MovieDetail />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/country/:code" element={<CountryDetail />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/city/:id" element={<CityDetail />} />
          <Route path="/genres" element={<Genres />} />
          <Route path="/people" element={<People />} />
          <Route path="/person/:id" element={<PersonDetail />} />
          <Route path="/festivals" element={<Festivals />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<ArticleDetail />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:id" element={<ThreadDetail />} />
          <Route path="/topics/:slug" element={<TopicPage />} />
          <Route path="/watchlist" element={<Watchlist />} />
          <Route path="/auth/callback" element={<SocialPulseCallback />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
